import { render, staticRenderFns } from "./ProviderLogo.vue?vue&type=template&id=2ba7e846&"
import script from "./ProviderLogo.vue?vue&type=script&lang=js&"
export * from "./ProviderLogo.vue?vue&type=script&lang=js&"
import style0 from "./ProviderLogo.vue?vue&type=style&index=0&id=2ba7e846&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports